import { redirect } from 'react-router-dom';
import { useAuthStore } from '../../features/auth/authStore';

export const loginLoader = async () => {
  const auth = useAuthStore.getState().auth;

  if (auth) {
    throw redirect('/v1/dashboard');
  }
};
